"use client";

import { useEffect } from "react";
import { isChunkLoadError, reloadForChunkError } from "./is-chunk-error";

// Catches chunk-load failures that bypass React's error boundaries:
// - <script> tag load failures fire `window.error` with the script as target
// - Unhandled rejections from `import()` fire `unhandledrejection`
// React error boundaries (error.tsx) handle the render-path case; this handles
// everything else.
export function ChunkErrorReloader() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      const target = event.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === "SCRIPT" || target.tagName === "LINK")
      ) {
        reloadForChunkError();
        return;
      }
      if (isChunkLoadError(event.error) || isChunkLoadError(event.message)) {
        reloadForChunkError();
      }
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadError(event.reason)) {
        reloadForChunkError();
      }
    };

    // `error` events on script/link tags do not bubble, so we need capture.
    window.addEventListener("error", onError, true);
    window.addEventListener("unhandledrejection", onRejection);

    return () => {
      window.removeEventListener("error", onError, true);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
